<!-- TODO: Multilang -->
<template>
        
    
  <v-dialog
    v-model="dialogChangePassword"
    persistent
    @keydown.esc="close"
    content-class="qmkey-modal-dialog-password"
    max-width="400px"
  >
    <v-card 
        :loading="loading"        
    >
      <v-card-title class="modal-card-title">
        <span class="qmkey-modal-h1 pb-0"> {{ $vuetify.lang.translator('user_menu.change_password') }} </span>
        <v-spacer></v-spacer>
        <v-btn
          class="qmkey-modal-dialog-close"
          text
          plain
          right
          small
          :ripple="false"
          @click="close"
        >
          <v-icon :ripple="false" small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="modal-card-title-divider mt-0 pt-0"></v-divider>
      <v-card-subtitle>
        
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title >
              {{ user.first_name }}, {{ user.last_name }}
            </v-list-item-title>
            <v-list-item-subtitle>{{ user.username }}, {{ user.email }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card-subtitle>
      <v-card-text>
        <v-form
          ref="changePasswordForm"
          v-model="valid"
          autocomplete="new-password"
          :value="valid"
        >
          <v-alert
            :value="alert"
            color="error"
            dark
            icon="mdi-alert"
            transition="scale-transition"
            outlined
          >
            {{ message }}
          </v-alert>
          <v-text-field
            v-model="currentUser.password"
            :placeholder="$vuetify.lang.translator('password_form.input_current_password')"
            required
            :label="$vuetify.lang.translator('password_form.current_password')"
            :type="false ? 'text' : 'password'"
            autocomplete="new-password"
            :rules="[rules.required]"
            :value="userPassword"
            @click:append="() => (value = !value)"
            @input="_ => (userPassword = _)"
            :class="['qmkey-form-input', 'required']"
            outlined
            dense
            background-color="#f2f2f2"
          />
          <v-text-field
            v-model="currentUser.password1"
            :placeholder="$vuetify.lang.translator('password_form.input_new_password')"
            required
            :label="$vuetify.lang.translator('password_form.new_password')"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show1 ? 'text' : 'password'"
            @click:append="show1 = !show1"
            autocomplete="new-password"
            :rules="[rules.required, rules.password, passwordChangeRule]"
            :class="['qmkey-form-input', 'required']"
            outlined
            dense
            background-color="#f2f2f2"
          />
          <v-text-field
            v-model="currentUser.password2"
            :placeholder="$vuetify.lang.translator('password_form.reinput_new_password')"
            required
            :label="$vuetify.lang.translator('password_form.confirm_new_password')"
            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show2 ? 'text' : 'password'"
            @click:append="show2 = !show2"
            autocomplete="new-password"
            :rules="[rules.required, rules.password, passwordConfirmationRule]"
            :class="['qmkey-form-input', 'required']"
            outlined
            dense
            background-color="#f2f2f2"
          />
        </v-form>
      </v-card-text>
      <v-card-actions class="qmkey-modal-dialog-card-actions">
        <v-spacer></v-spacer>
        <v-btn small class="qmkey-modal-dialog-button-secundary" @click="clear"
        color="#FFFFFF">{{ $vuetify.lang.translator('dialog.clear') }}</v-btn>
        <v-btn small class="qmkey-modal-dialog-button-submit"
          text
          :disabled="!valid" @click.prevent="changePassword">{{ $vuetify.lang.translator('dialog.save') }}</v-btn>
        
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ChangePasswordForm',
  cache: false,
  data: function() {
    return {
      loading: false,
      message: null,
      show1: false,
      show2: false,
      show3: false,
      userPassword: '',
      valid: false,
      rules: {
        required: value => !!value || 'Required.',
        password: value => {
          const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/
          return (
            !this.shouldValidate || pattern.test(value) ||
            'Min. 8 characters with at least one capital letter, a number and a special character.'
          )
        },
        confirmed: value =>
          value != this.currentUser.password1 || 'Password no match',
      },
      alert: false,
      err: '',
      currentUser: {},
    }
  },
  props: {
    dialogChangePassword: {
      type: Boolean,
      default: false,
    },
    shouldValidate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    passwordChangeRule() {
      return () =>
        this.currentUser.password0 != this.currentUser.password1 ||
        'New Password must be different'
    },
    passwordConfirmationRule() {
      return () =>
        this.currentUser.password1 === this.currentUser.password2 ||
        'Password must match'
    },
    ...mapGetters(['sitePath', 'user']),
  },
  methods: {
    changePassword: function(evt) {
      if (evt) evt.preventDefault()
      if (!this.sitePath) {
        alert('No client session found')
        return
      }
      this.loading = true
      this.message = ''
      this.$http
        .post(
          this.$base +
            '/api/v1' +
            this.sitePath +
            '/user/' +
            this.user.id +
            '/pwd_change/',
          this.currentUser,
        )
        .then(() => {
          this.loading = false
          this.clear()
          this.$emit('close-dialog', false)
        })
        .catch(err => {
          this.render_form_errors(err)
          this.alert = true
        })
    },
    clear: function() {
      this.message = ''
      this.alert = false
      this.$refs.changePasswordForm.resetValidation()
      this.currentUser.password = ''
      this.currentUser.password1 = ''
      this.currentUser.password2 = ''
    },
    close: function() {
      this.$refs.changePasswordForm.reset()
      this.message = ''
      this.alert = false
      //   this.dialogChangePassword = false
      this.$emit('close-dialog', false)
    },
  },
}
</script>
<style lang="scss">
@import '@/sass/modalform.scss';
</style>
